import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { IntlActions } from 'react-redux-multilingual'
import Pace from 'react-pace-progress'

// Import custom components
import store from '../../../store';
import NavBar from "./common/navbar";
import SideBar from "./common/sidebar";
import CartContainer from "./../../../containers/CartContainer";
import TopBarDark from "./common/topbar-dark";
import { changeCurrency } from '../../../actions'
import { connect } from "react-redux";
import Logo from "../../../assets/logo/ezlogo1.png";
import AddCredit from "../../../assets/icon/wallet.png"
import Ticket from "../../../assets/icon/ticket.png"
import Tachometer from "../../../assets/icon/tachometer.png"
import Transaction from "../../../assets/icon/transaction.png"
import EditUser from "../../../assets/icon/edit-user.png"
import Logout from "../../../assets/icon/logout.png"
import User from "../../../assets/icon/user1.png"
import Wallet2 from "../../../assets/icon/wallet2.png"
class HeaderThree extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false
        }
    }
    logout = (e) => {
        e.preventDefault();
        window.localStorage.removeItem("user_info");
        window.location.reload(window.location.href);
    };
    /*=====================
         Pre loader
         ==========================*/
    componentDidMount() {
        setTimeout(function () {
            document.querySelector(".loader-wrapper").style = "display: none";
        }, 2000);
    }

    componentWillMount() {
        window.addEventListener('scroll', this.handleScroll);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = () => {
        let number = window.pageXOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

        // if (number >= 300) {
        //     if (window.innerWidth < 576) {
        //         document.getElementById("sticky").classList.remove('fixed');
        //     } else
        //         document.getElementById("sticky").classList.add('fixed');
        // } else {
        //     document.getElementById("sticky").classList.remove('fixed');
        // }
    }

    changeLanguage(lang) {
        store.dispatch(IntlActions.setLocale(lang))
    }

    openNav() {
        var openmyslide = document.getElementById("mySidenav");
        if (openmyslide) {
            openmyslide.classList.add('open-side')
        }
    }
    openSearch() {
        document.getElementById("search-overlay").style.display = "block";
    }

    closeSearch() {
        document.getElementById("search-overlay").style.display = "none";
    }

    load = () => {
        this.setState({ isLoading: true });
        fetch().then(() => {
            // deal with data fetched
            this.setState({ isLoading: false })
        })
    };

    render() {

        return (
            <div>
                <header id="sticky" className="sticky header-2 header-6">
                    {this.state.isLoading ? <Pace color="#27ae60" /> : null}
                    {/*Top Header Component*/}
                    <TopBarDark />

                    <div className="container">
                        {/* <div className="row"> */}
                        {/* <div className="col-sm-12">
                                <div className="main-menu border-section border-top-0">
                                    <div className="brand-logo layout2-logo">
                                        <img src={Logo} alt="" className="img-fluid" />
                                    </div>
                                    <div>
                                        <form className="form_search" role="form">
                                            <input id="query search-autocomplete" type="search"
                                                   placeholder="Find the best for your pet..."
                                                   className="nav-search nav-search-field" aria-expanded="true" />
                                                <button type="submit" name="nav-submit-button" className="btn-search">
                                                    <i className="fa fa-search"></i>
                                                </button>
                                        </form>
                                    </div>
                                    <div className="menu-right pull-right">
                                        <div>
                                            <div className="icon-nav">
                                                <ul>
                                                    <li className="onhover-div mobile-search">
                                                        <div><img src={`${process.env.PUBLIC_URL}/assets/images/icon/search.png`} onClick={this.openSearch} className="img-fluid" alt="" />
                                                            <i className="fa fa-search" onClick={this.openSearch}></i></div>
                                                    </li>
                                                    <li className="onhover-div mobile-setting">
                                                        <div><img src={`${process.env.PUBLIC_URL}/assets/images/icon/setting.png`} className="img-fluid" alt="" />
                                                            <i className="fa fa-cog"></i></div>
                                                        <div className="show-div setting">
                                                            <h6>language</h6>
                                                            <ul>
                                                                <li><a href={null} onClick={() => this.changeLanguage('en')}>English</a> </li>
                                                                <li><a href={null} onClick={() => this.changeLanguage('fn')}>French</a> </li>
                                                            </ul>
                                                            <h6>currency</h6>
                                                            <ul className="list-inline">
                                                                <li><a href={null} onClick={() => this.props.changeCurrency('€')}>euro</a> </li>
                                                                <li><a href={null} onClick={() => this.props.changeCurrency('₹')}>rupees</a> </li>
                                                                <li><a href={null} onClick={() => this.props.changeCurrency('£')}>pound</a> </li>
                                                                <li><a href={null} onClick={() => this.props.changeCurrency('$')}>doller</a> </li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    <CartContainer />
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        {/* </div> */}
                    </div>
                    <div className="" style={{ padding: '1rem' }}>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="main-nav-center" style={{ justifyContent: 'space-between' }}>
                                    <Link to='/' className="brand-logo layout2-logo pb-0">
                                        <img src={Logo} alt="" className="img-fluid" />
                                    </Link>
                                    <NavBar />
                                    <div className="login-btn mx-5 px-3 text-right">
                                        <ul className="header-dropdown">
                                            {!localStorage.getItem('user_info') ?
                                                <Link to={`${process.env.PUBLIC_URL}/pages/login`} >
                                                    <li className="mobile-wishlist"><a href="#" style={{ fontSize: '15px' }}><i className="fa fa-user ml-2" aria-hidden="true" />
                                                        ثبت نام/ورود
                                                    </a></li>
                                                </Link>
                                                :
                                                <li className="onhover-dropdown mobile-account">
                                                    <i className="fa fa-user" aria-hidden="true"></i>
                                                    <span style={{ margin: '0 4px 0 16px' }}>
                                                        {JSON.parse(localStorage.getItem('user_info')).fullName}
                                                    </span>

                                                    <ul className="onhover-show-div text-right"><Link to={`${process.env.PUBLIC_URL}/pages/profile`} >


                                                        <div style={{ display: 'flex', alignItems: 'start', justifyContent: 'start' }}>

                                                            <div style={{ width: '40px', height: '40px' }}>
                                                                <img src={User} />
                                                            </div>
                                                            <div className='mt-2 mr-2'>
                                                                <h6> {JSON.parse(localStorage.getItem('user_info')).fullName}</h6>

                                                            </div>
                                                        </div>

                                                    </Link>
                                                        {/* <li>
                                                            <a href="#" data-lng="en">
                                                                <div className='icon-box'>
                                                                    <img src={Wallet2} />

                                                                </div>
                                                                <span style={{ color: 'red' }}>

                                                                    0 تومان
                                                                </span>
                                                            </a>
                                                        </li> */}
                                                        <hr role="tournament6" />

                                                        <li>
                                                            <div className='d-flex'>
                                                                <div className='icon-box mx-2'>
                                                                    {/* <img src={Tachometer} /> */}
                                                                    <i class="fa fa-tachometer" aria-hidden="true"></i>

                                                                </div>
                                                                پیشخوان
                                                            </div>

                                                        </li>
                                                        <hr className='my-1' />
                                                        {/* <li>
                                                            <a href="#" data-lng="es">
                                                                <div className='icon-box'>
                                                                    <img src={AddCredit} />

                                                                </div>
                                                                افزودن اعتبار
                                                            </a>
                                                        </li>
                                                        <hr className='my-1' />
                                                        <li>
                                                            <a href="#" data-lng="es">
                                                                <div className='icon-box'>
                                                                    <img src={Transaction} />

                                                                </div>
                                                                تراکنش ها
                                                            </a>
                                                        </li>
                                                        <hr className='my-1' />
                                                        <li>
                                                            <a href="#" data-lng="es">
                                                                <div className='icon-box'>
                                                                    <img src={Ticket} />

                                                                </div>
                                                                تیکت ها
                                                            </a>
                                                        </li>
                                                        <hr className='my-1' /> */}
                                                        <li>

                                                            <Link to='/pages/profile#edit-Profile' data-lng="es">  <div className='d-flex'>
                                                                <div className='icon-box mx-2'>
                                                                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i>


                                                                </div>
                                                                ویرایش پروفایل
                                                            </div></Link>
                                                        </li>
                                                        <hr className='my-1' />
                                                        <li>

                                                            <Link to='/pages/profile#orders' data-lng="es">  <div className='d-flex'>
                                                                <div className='icon-box mx-2'>
                                                                    {/* <img src={EditUser} /> */}
                                                                    <i class="fa fa-file-text-o" aria-hidden="true"></i>


                                                                </div>
                                                                سفارشات
                                                            </div></Link>
                                                        </li>
                                                        <hr className='my-1' />
                                                        <li>
                                                            <div className='d-flex' onClick={this.logout} data-lng="es">
                                                                <div className='icon-box mx-2'>
                                                                    <i class="fa fa-sign-out" aria-hidden="true"></i>
                                                                </div>
                                                                خروج
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                    {/* <div>
                                        <form className="form_search" role="form">
                                            <input id="query search-autocomplete" type="search"
                                                placeholder="جستجو"
                                                className="nav-search nav-search-field" aria-expanded="true" />
                                            <button type="submit" name="nav-submit-button" className="btn-search">
                                                <i className="fa fa-search"></i>
                                            </button>
                                        </form>
                                    </div> */}
                                    {/* <div className="main-menu border-top-0">

                                        <div className="menu-right pull-right">
                                            <div>
                                                <div className="icon-nav">
                                                    <ul>
                                                        <li className="onhover-div mobile-search">
                                                            <div><img src={`${process.env.PUBLIC_URL}/assets/images/icon/search.png`} onClick={this.openSearch} className="img-fluid" alt="" />
                                                                <i className="fa fa-search" onClick={this.openSearch}></i></div>
                                                        </li>
                                                        <li className="onhover-div mobile-setting">
                                                            <div><img src={`${process.env.PUBLIC_URL}/assets/images/icon/setting.png`} className="img-fluid" alt="" />
                                                                <i className="fa fa-cog"></i></div>
                                                            <div className="show-div setting">
                                                                <h6>language</h6>
                                                                <ul>
                                                                    <li><a href={null} onClick={() => this.changeLanguage('en')}>English</a> </li>
                                                                    <li><a href={null} onClick={() => this.changeLanguage('fn')}>French</a> </li>
                                                                </ul>
                                                                <h6>currency</h6>
                                                                <ul className="list-inline">
                                                                    <li><a href={null} onClick={() => this.props.changeCurrency('€')}>euro</a> </li>
                                                                    <li><a href={null} onClick={() => this.props.changeCurrency('₹')}>rupees</a> </li>
                                                                    <li><a href={null} onClick={() => this.props.changeCurrency('£')}>pound</a> </li>
                                                                    <li><a href={null} onClick={() => this.props.changeCurrency('$')}>doller</a> </li>
                                                                </ul>
                                                            </div>
                                                        </li>
                                                        <CartContainer />
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                <div id="search-overlay" className="search-overlay">
                    <div>
                        <span className="closebtn" onClick={this.closeSearch} title="Close Overlay">×</span>
                        <div className="overlay-content">
                            <div className="container">
                                <div className="row">
                                    <div className="col-xl-12">
                                        <form>
                                            <div className="form-group">
                                                <input type="text" className="form-control" id="exampleInputPassword1" placeholder="Search a Product" />
                                            </div>
                                            <button type="submit" className="btn btn-primary"><i className="fa fa-search"></i></button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(null,
    { changeCurrency }
)(HeaderThree);